import { z } from "zod";

/**
 * Editable company address fields on hub/settings/company. All string fields
 * default to "" for controlled inputs; empty strings are converted to null when
 * building the API payload. Name/email/website remain read-only (Salesforce).
 */
export const companyProfileFormSchema = z.object({
  addressLine1: z.string().max(255),
  city: z.string().max(255),
  state: z.string().max(255),
  zipCode: z.string().max(32),
  isMailingAddressSame: z.boolean(),
  mailingAddressLine1: z.string().max(255),
  mailingCity: z.string().max(255),
  mailingState: z.string().max(255),
  mailingZipCode: z.string().max(32),
});

export type CompanyProfileFormData = z.infer<typeof companyProfileFormSchema>;
